export interface IAPIException {
  success: boolean;
  message?: string;
  errors?: {
    errorCode: number;
    message: string;
  }[];
}
